import { render } from "./TravelHistory.vue?vue&type=template&id=03e111e4&scoped=true"
import script from "./TravelHistory.vue?vue&type=script&lang=js"
export * from "./TravelHistory.vue?vue&type=script&lang=js"

import "./TravelHistory.vue?vue&type=style&index=0&id=03e111e4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e111e4"]])

export default __exports__